<div class="container booking-container">
    <form [formGroup]="reservationForm">
        <div class="row d-block text-center pb-3">
            <h1 class="font-weight-bold section-title">Reserva de Habitaciones</h1>
        </div>

        <div class="booking-section">
            <div class="row">
                <div class="col-7">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Rango de fechas</mat-label>
                        <mat-date-range-input [rangePicker]="picker" [min]="minDate">
                            <input matStartDate formControlName="checkInDate" placeholder="Fecha de inicio">
                            <input matEndDate formControlName="checkOutDate" placeholder="Fecha de fin">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
                <div class="col-2">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Huéspedes</mat-label>
                            <input matInput type="number" formControlName="guestCount" min="1" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-3">
                    <div class="button-container">
                        <button (click)="searchRooms()" [disabled]="!totalNights">Buscar Habitaciones</button>
                    </div>
                </div>
            </div>


            <!-- Cantidad de huéspedes y Botón en la misma línea -->
            <div class="guests-container mt-3">



            </div>
        </div>


        <div *ngIf="rooms.length > 0" class="booking-section">
            <!-- Habitaciones en dos columnas -->
            <div *ngIf="showRooms" class="mt-3">
                <h2 class="section-title">Habitaciones Disponibles</h2>

                <p>Estadía de {{ totalNights }} noches</p>
                <div class="rooms-container">
                    <div *ngFor="let room of rooms" class="room-card" [class.selected]="isRoomSelected(room)"
                        (click)="toggleRoomSelection(room)">

                        <div><strong>{{ room.name }}</strong> - N° {{ room.number }} </div>
                        <div><strong>${{ room.nightPrice }} por noche</strong></div>
                        <div>Capacidad: {{ room.capacity }} personas</div>

                        <div *ngIf="room.bedsSingle > 0" class="float-left">
                            <label>{{ room.bedsSingle }}</label>
                            <!-- ícono cama simple -->
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 19V8H18V19H20V21H4V19H6ZM10 10V12H14V10H10ZM8 14V16H16V14H8Z"
                                    fill="black" />
                            </svg>
                        </div>

                        <div *ngIf="room.bedsDouble > 0" class="float-left">
                            <label>{{ room.bedsDouble }}</label>
                            <!-- ícono cama doble -->
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 19V7H21V19H22V21H2V19H3ZM6 9V11H10V9H6ZM14 9V11H18V9H14ZM6 13V15H18V13H6Z"
                                    fill="black" />
                            </svg>
                        </div>

                        <!-- Botón solo si la habitación está seleccionada -->
                        <button *ngIf="isRoomSelected(room)" (click)="openSelectDialog($event, room)"
                            class="select-room-button">
                            Cambiar precio
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <div *ngIf="this.reservationDetails.value.length > 0" class="booking-section">
            <!-- Resumen de habitaciones seleccionadas -->
            <div class="mt-3">
                <div class="mt-3">
                    <div [formGroup]="reservationForm.get('bookingPerson')">
                        <h2 class="section-title">Datos del responsable de la reserva</h2>
                        <div class="grid-container">

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Tipo de documento</mat-label>
                                <mat-select formControlName="documentType">
                                    <mat-option [value]="null">Seleccione...</mat-option>
                                    <mat-option *ngFor="let type of documentTypes" [value]="type.value">
                                        {{ type.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Número de documento</mat-label>
                                <input matInput formControlName="documentNumber" type="text"
                                    (keydown.enter)="trySearchBookingPerson()" (blur)="trySearchBookingPerson()" />
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="firstName" type="text" />
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Apellido</mat-label>
                                <input matInput formControlName="lastName" type="text" />
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Código de área</mat-label>
                                <input matInput formControlName="areaCode"  placeholder="Sin 0 - ej: +54388" type="text" />
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Teléfono</mat-label>
                                <input matInput formControlName="phoneNumber" placeholder="sin 15 - ej: 3456888" type="text" />
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Email</mat-label>
                                <input matInput formControlName="email" type="email"
                                    placeholder="ej: email@email.com" />
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>País de origen</mat-label>
                                <mat-select formControlName="countryOfOrigin">
                                    <ngx-mat-select-search [formControl]="countryFilterCtrl"
                                        placeholderLabel="Buscar país..."></ngx-mat-select-search>
                                    <mat-option>Seleccione...</mat-option>
                                    <mat-option *ngFor="let country of filteredCountries" [value]="country.name">
                                        {{ country.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Dirección de origen</mat-label>
                                <input matInput formControlName="originAddress" type="text" />
                            </mat-form-field>

                            <mat-checkbox formControlName="isGuest" class="isGuest-chk">¿También es
                                huésped?</mat-checkbox>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="booking-section">
            <div class="row justify-content-end">
                <button *ngIf="!reservationId" (click)="confirmReservation()"
                    [disabled]="reservationForm.invalid || reservationForm.controls.bookingPerson.disabled"
                    class="mt-3 me-2 action-btn">
                    Confirmar reserva
                </button>
                <button *ngIf="reservationId" (click)="updateReservation()"
                    [disabled]="reservationForm.invalid || reservationForm.controls.bookingPerson.disabled"
                    class="mt-3 me-2 action-btn">
                    Guardar cambios
                </button>
                <button class="mt-3 ml-1 action-btn cancel-btn" (click)="goToHome()"
                    [disabled]="reservationForm.controls.bookingPerson.disabled">
                    Cancelar
                </button>
            </div>
        </div>
    </form>
</div>